import { useEffect } from "react";

/**
 * Injects <meta name="robots" content="noindex, nofollow"> into the head.
 * Mount this on any private/admin page (admin login, dashboard, distributor
 * portal, checkout, cart, order success) so search engines never index them.
 * Removes the tag on unmount so public pages are not affected.
 */
export default function NoIndexMeta() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    const head = document.head;
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow");
    meta.dataset.seoNoindex = "true";
    head.appendChild(meta);
    return () => meta.remove();
  }, []);
  return null;
}
